// Разбивка длинных абзацев документа перед печатью в PDF (PdfDocuments.vue, onclone html2canvas).
//
// Абзац длиннее LONG_PARAGRAPH символов режется по предложениям на куски примерно по
// CHUNK_LENGTH символов, каждый кусок — отдельный <p> со стилями исходного.
//
// ПОЧЕМУ ЧЕРЕЗ УЗЛЫ, А НЕ innerHTML. Значения документа экранирует сервер, фронт их не
// раскодирует. Прежний код собирал куски из p.textContent и писал обратно через p.innerHTML:
// textContent раскодирует экранированный текст (&lt;b&gt; → <b>), innerHTML разбирает его как
// разметку — ФИО или адрес из формы виджета в длинном абзаце снова становились разметкой в
// браузере сотрудника (ревью api#872). Здесь куски пишутся через textContent.

const LONG_PARAGRAPH = 300;
const CHUNK_LENGTH = 250;

// Нарезка прежняя (предложения по [.!?], перенос перед предложением, которое не влезает в
// CHUNK_LENGTH, после каждого ". "), кроме пустого первого куска — его больше нет.
export function paragraphChunks(text) {
  const chunks = [];
  let current = '';
  let currentLength = 0;

  text.split(/[.!?]+/).forEach((sentence) => {
    if (currentLength + sentence.length > CHUNK_LENGTH && current) {
      chunks.push(current);
      current = '';
      currentLength = 0;
    }
    current += `${sentence}. `;
    currentLength += sentence.length;
  });
  if (current) chunks.push(current);

  return chunks;
}

// Заменяет длинный абзац несколькими; короткие не трогает.
export function splitLongParagraph(p) {
  const text = p.textContent;
  if (text.length <= LONG_PARAGRAPH) return;

  p.replaceWith(...paragraphChunks(text).map((chunk) => {
    const piece = p.cloneNode(false);
    piece.textContent = chunk;
    return piece;
  }));
}
